// stores/menu.js
import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { checkIsMobile } from '@/utils/deviceDetection';
import { useAuthStore } from '@/stores/auth';
import { useRouter } from 'vue-router';

export const useMenuStore = defineStore('menu', () => {
  const menuItems = ref([
    {
      label: 'Home',
      authorized: true, // 모든 사용자에게 허용
      items: [
        {
          label: '대시보드',
          icon: 'pi pi-fw pi-home',
          to: '/',
        },
      ],
    },
    {
      label: 'Asset Management',
      items: [
        {
          label: 'IT 자산관리',
          icon: 'pi pi-fw pi-desktop',
          items: [
            {
              label: '자산그룹관리',
              icon: 'pi pi-fw pi-server',
              to: '/asset/AssetGroupMng',
            },
            {
              label: '자산조회',
              icon: 'pi pi-fw pi-wallet',
              to: '/asset/AssetManagement',
            },
            {
              label: '제조사관리',
              icon: 'pi pi-fw pi-wrench',
              to: '/asset/ManufacMng',
            },
            {
              label: '자산분류관리',
              icon: 'pi pi-fw pi-directions',
              to: '/asset/CatMng',
            },
            {
              label: '사무실관리',
              icon: 'pi pi-fw pi-building',
              to: '/asset/OfficeMng',
            },
          ],
        },
        {
          label: '협력업체관리',
          icon: 'pi pi-fw pi-building',
          items: [
            {
              label: '계약조회',
              icon: 'pi pi-fw pi-pencil',
              to: '/asset/AssetContMng',
            },
            {
              label: '업체조회',
              icon: 'pi pi-fw pi-directions',
              to: '/asset/AssetVendorManagement',
            },
            {
              label: '담당자조회',
              icon: 'pi pi-fw pi-bolt',
              to: '/asset/VendorUser',
            },
          ],
        },
        {
          label: '사용자관리',
          icon: 'pi pi-fw pi-user',
          to: '/asset/Users',
        },
      ],
    },
    {
      label: 'ISSUE MANAGEMENT',
      items: [
        {
          label: '고장신고',
          icon: 'pi pi-fw pi-building',
          items: [
            {
              label: '고장신고요청',
              icon: 'pi pi-fw pi-list',
              to: '/issue/IssueReportDialog',
            },
            {
              label: '고장신고목록',
              icon: 'pi pi-fw pi-list',
              to: '/issue/IssueReportList',
            },
          ]
        }
      ],
    },

    {
      label: 'IT Maintenance',
      items: [
        {
          label: '정기점검보고서',
          icon: 'pi pi-fw pi-bookmark',
          to: '/asset/AssetMaintenanceReportDialog',
        },
        {
          label: '기술지원요청',
          icon: 'pi pi-fw pi-bookmark',
          to: '/asset/AssetTechSupportReq',
        },
        {
          label: '정기점검현황',
          icon: 'pi pi-fw pi-bookmark',
          to: '/asset/AssetMaintenanceReportStatus',
        },
      ],
    },
    {
      label: 'Survey Management',
      items: [
        {
          label: '설문 관리',
          icon: 'pi pi-fw pi-clipboard',
          items: [
            {
              label: '설문 목록',
              icon: 'pi pi-fw pi-list',
              to: '/survey/list',
            },
            {
              label: '설문 설정',
              icon: 'pi pi-fw pi-cog',
              to: '/survey/setting',
            },
            {
              label: '설문 설계',
              icon: 'pi pi-fw pi-pencil',
              to: '/survey/design',
            },
            {
              label: '설문 조회',
              icon: 'pi pi-fw pi-eye',
              to: '/survey/view',
            },
            {
              label: '설문 참여자 관리',
              icon: 'pi pi-fw pi-users',
              to: '/survey/participants',
            },
          ],
        },
        // {
        //   label: 'JSC 콘퍼런스',
        //   icon: 'pi pi-fw pi-users',
        //   items: [
        //     {
        //       label: '설문 응답 목록',
        //       icon: 'pi pi-fw pi-table',
        //       to: '/survey/jscadmin',
        //     },
        //     {
        //       label: '질문 관리',
        //       icon: 'pi pi-fw pi-question-circle',
        //       to: '/survey/jscqv',
        //     },
        //     {
        //       label: '사용자 관리',
        //       icon: 'pi pi-fw pi-user',
        //       to: '/survey/u',
        //     },
        //     {
        //       label: 'OX 퀴즈 관리',
        //       icon: 'pi pi-fw pi-check-square',
        //       to: '/survey/oxadmin',
        //     },
        //   ],
        // },
        // {
        //   label: '설문 참여',
        //   icon: 'pi pi-fw pi-sign-in',
        //   items: [
        //     {
        //       label: '참가 신청',
        //       icon: 'pi pi-fw pi-user-plus',
        //       to: '/survey/jsc',
        //     },
        //     {
        //       label: '참가 취소',
        //       icon: 'pi pi-fw pi-user-minus',
        //       to: '/survey/jscc',
        //     },
        //     {
        //       label: '미참가 신고',
        //       icon: 'pi pi-fw pi-times-circle',
        //       to: '/survey/jscn',
        //     },
        //     {
        //       label: 'Day 1 설문',
        //       icon: 'pi pi-fw pi-calendar',
        //       to: '/survey/jscd1',
        //     },
        //     {
        //       label: 'Day 2 설문',
        //       icon: 'pi pi-fw pi-calendar-plus',
        //       to: '/survey/jscd2',
        //     },
        //     {
        //       label: 'OX 퀴즈',
        //       icon: 'pi pi-fw pi-check-square',
        //       to: '/survey/oxgame',
        //     },
        //   ],
        // },
      ],
    },
  ]);

  // 모바일 기기에서 보여줄 메뉴 아이템
  const mobileMenuItems = ref([
    {
      label: 'Home',
      authorized: true, // 모든 사용자에게 허용
      items: [
        {
          label: 'Home',
          icon: 'pi pi-fw pi-home',
          to: '/',
        },
      ],
    },
    {
      label: 'Asset Management',
      items: [
        {
          label: 'IT 자산관리',
          icon: 'pi pi-fw pi-desktop',
          items: [
            {
              label: '자산조회',
              icon: 'pi pi-fw pi-wallet',
              to: '/asset/AssetManagement',
            },
          ],
        },
      ],
    },
    {
      label: 'ISSUE MANAGEMENT',
      items: [
        {
          label: '고장신고',
          icon: 'pi pi-fw pi-building',
          items: [
            {
              label: '고장신고요청',
              icon: 'pi pi-fw pi-list',
              to: '/issue/IssueReportDialog',
            },
            {
              label: '고장신고목록',
              icon: 'pi pi-fw pi-list',
              to: '/issue/IssueReportList',
            },
          ]
        }
      ],
    },
    {
      label: 'Survey Management',
      items: [
        {
          label: '설문 관리',
          icon: 'pi pi-fw pi-clipboard',
          items: [
            {
              label: '설문 목록',
              icon: 'pi pi-fw pi-list',
              to: '/survey/list',
            },
            {
              label: 'JSC 콘퍼런스',
              icon: 'pi pi-fw pi-users',
              to: '/survey/jscadmin',
            },
          ],
        },
      ],
    },
  ]);

  // 벤더 사용자 체크
  const authStore = useAuthStore();
  const router = useRouter();
  
  // 벤더 사용자일 때 excludeVendor 메타가 true인 메뉴 제외
  const filterVendorMenuItems = (items) => {
    if (!items) return [];
    
    return items.filter(item => {
      // to 속성이 있는 경우 라우터 메타 정보 확인
      if (item.to && authStore.isVendorUser) {
        try {
          const route = router.resolve(item.to);
          if (route.meta && route.meta.excludeVendor) {
            return false; // 벤더 사용자 제외
          }
        } catch (error) {
          console.warn(`Invalid route: ${item.to}`);
        }
      }
      
      // 하위 메뉴가 있는 경우 재귀적으로 처리 (새로운 객체 생성)
      if (item.items) {
        const filteredItems = filterVendorMenuItems(item.items);
        // 하위 메뉴가 모두 제거된 경우 상위 메뉴도 제거
        if (filteredItems.length === 0) {
          return false;
        }
        // 새로운 객체를 생성하여 반응성 문제 방지
        return {
          ...item,
          items: filteredItems
        };
      }
      
      return item;
    });
  };

  // 모바일 여부와 벤더 사용자 여부에 따라 메뉴 아이템 반환
  const filteredMenuItems = computed(() => {
    const baseItems = checkIsMobile() ? mobileMenuItems.value : menuItems.value;
    return filterVendorMenuItems(baseItems);
  });

  const findMenuItemByPath = (path) => {
    const findInItems = (items) => {
      for (const item of items || []) {
        if (item.to === path) {
          return item;
        }
        if (item.items) {
          const found = findInItems(item.items);
          if (found) return found;
        }
      }
      return null;
    };

    return findInItems(filteredMenuItems.value);
  };

  const findMenuPath = (targetPath) => {
    const result = [];

    const findPath = (items, target) => {
      for (const item of items || []) {
        if (item.to === target) {
          result.push(item);
          return true;
        }
        if (item.items) {
          result.push(item);
          if (findPath(item.items, target)) {
            return true;
          }
          result.pop();
        }
      }
      return false;
    };

    findPath(filteredMenuItems.value, targetPath);
    return result;
  };

  return {
    menuItems: filteredMenuItems,
    findMenuItemByPath,
    findMenuPath,
  };
});
